import React, { useState, useEffect, useRef } from "react";
import FeatherIcon from "feather-icons-react";
import { getInitials } from "../../constants";

export const SquareAvatar = ({ src, name }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const imgRef = useRef(null);

    // Same fix as SmoothAvatar.js: this component's instance is keyed by
    // slot/row position, not by `src`, so without this a slot whose first
    // load attempt ever failed (or that started with no photo) stayed stuck
    // showing the no-photo placeholder forever, even after `src` later points
    // at a real, loadable photo.
    //
    // Also same fix for the browser-cache race: a cached image finishes
    // loading synchronously, often before onLoad's listener is even attached,
    // so the `load` event never fires again and `loaded` got stuck false
    // forever despite the photo being fully loaded in the DOM already -
    // looked like "sometimes shows the photo, sometimes doesn't" on repeated
    // mounts of the same src. `.complete` catches what the event misses.
    useEffect(() => {
        if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
            setLoaded(true);
            setError(false);
        } else {
            setLoaded(false);
            setError(false);
        }
    }, [src]);

    if (!src || error) {
        return name
            ? <div className="square-no-thumbnail initials">{getInitials(name)}</div>
            : <div className="square-no-thumbnail"><FeatherIcon icon="camera-off" /></div>;
    }

    return (
        <div style={{ position: "relative", display: "inline-flex", justifyContent: "center", alignItems: "center" }}>
            <img
                ref={imgRef}
                src={src}
                className="square-thumbnail"
                onLoad={() => setLoaded(true)}
                onError={() => setError(true)}
                style={{
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 0.4s ease"
                }}
            />
            <div
                className="square-no-thumbnail"
                style={{
                    position: "absolute",
                    opacity: loaded ? 0 : 1,
                    transition: "opacity 0.4s ease",
                    pointerEvents: "none"
                }}
            >
                <FeatherIcon icon="camera-off" />
            </div>
        </div>
    );
};
